import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import { Client } from 'src/app/model/client';
import { Project } from 'src/app/model/project';
import { AssignScheduler, batches, Scheduler, SchedulerData } from 'src/app/model/schedulers-data';
import { ClientService } from 'src/app/service/client.service';
import { NotificationService } from 'src/app/service/notification.service';
import { ProjectService } from 'src/app/service/project.service';
import { SchedulerService } from 'src/app/service/scheduler.service';

@Component({
  selector: 'app-assign-modal',
  templateUrl: './assign-modal.component.html',
  styleUrls: ['./assign-modal.component.scss']
})
export class AssignModalComponent implements OnInit {

  _assignForm: FormGroup;
  assignSchedulerRequest: AssignScheduler = new AssignScheduler();
  clients: Client[];
  selectedClient: string;
  projects: Project[];
  project: Project;
  selectedProject: string;
  newSchedulers: Scheduler[];
  assignedSchedulers: Scheduler[];
  selectedProjects: Project[] = [];

  batches: any [];
  newBatches: batches[];
  assignedBatches: any [];

  isAssigned: boolean = false;

  constructor(private _formBuilder: FormBuilder,
    private clientService: ClientService,
    private projectService: ProjectService,
    private schedulerService: SchedulerService,
    private _localStorage: LocalStorageService,
    private _notificationService: NotificationService,
    public dialogRef: MatDialogRef<AssignModalComponent>,
    @Inject(MAT_DIALOG_DATA) public assignedScheduler: Scheduler) { }

  ngOnInit() {
    this.getClientList();
    this.newSchedulers = []
    //alert(this.assignedScheduler.isAssigned);
    this.isAssigned = this.assignedScheduler.isAssigned;
    if (this.assignedScheduler.isAssigned) {
      this.newSchedulers.push(this.assignedScheduler)
      this.selectedClient = this.assignedScheduler.clientId;
      this.getProjects(this.selectedClient);
      //this.selectedProject = this.assignedScheduler.projectId;
      //this.getBatches(this.selectedProject);
      //this.assignedBatches = this.assignedScheduler.assignedBatches;
      this.loadProjects(this.assignedScheduler.projectIds);
      this._assignForm = this._formBuilder.group({
        clientId: new FormControl({ value: this.selectedClient, disabled: true }),
        projectIds: new FormControl({ value: this.assignedScheduler.projectIds, disabled: true }),
        //assignedBatches: new FormControl({ value: this.assignedBatches, disabled: true }),
      });
    }else{
      this.newSchedulers.push(this.assignedScheduler)
      this._assignForm = this._formBuilder.group({
        clientId: new FormControl({ value: this.selectedClient, disabled: false }),
        projectIds: new FormControl([]),
        //assignedBatches: new FormControl(this.assignedBatches),
      });
    }
  }

  getClientList() {
    this.clientService.getClients().subscribe(result => {
      if (!result) {
        return;
      }
      this.clients = result.clients;
      console.log("Client Name: " + this.clients[0].clientName);
    }, error => console.log(error));
  }

  getProjectsByClient({ value }) {
    //alert(value);
    this.getProjects(value);
  }

  getProjects(value: string) {
    //alert(value);
    this.projectService.getProjects(value)
      .subscribe(result => {
        if (!result) {
          return;
        }
        console.log(result);
        this.projects = result.projects;
        this.selectedProject = this.assignedScheduler.projectId;
        console.log("projects: " + this.projects);
      }, error => console.log(error));
  }

  getSchedulersByProject({ value }) {
    //alert(value);
    this.loadProjects(value);
    //this.getBatches(value);
  }

  loadProjects(value: number[]) {
    //alert(value);
    this.projectService.getProjectList(value)
      .subscribe(result => {
        if (!result) {
          return;
        }
        console.log(result);
        this.selectedProjects = result.projects;
        //this.selectedProjects.push(this.project);
        console.log("selectedProjects: " + this.selectedProjects);
      }, error => console.log(error));
  }

  getSchedulers(value: string) {
    //alert(value);
    this.schedulerService.getSchedulersByProjectId(value)
      .subscribe(result => {
        if (!result) {
          return;
        }
        console.log(result);
        this.assignedSchedulers = result.schedulers;
        //alert(this.assignedSchedulers);
        //console.log("projects: " + this.projects);
      }, error => console.log(error));
  }

  getBatchesByProject({ value }) {
    //alert(value);
    //this.getBatches(value);
  }

  getBatches(value: string) {
    //alert(value);
    this.schedulerService.getBatchesbySelectedProjectId(value)
      .subscribe(result => {
        if (!result) {
          return;
        }
        console.log(result);
        //alert(result.batches);
        this.batches = result.batches;
        console.log("batches: " + this.batches);
      }, error => console.log(error));
  }

  assign() {
    this.assignSchedulerRequest = this._assignForm.value;
    //this.assignSchedulerRequest.schedulers = [];
    //this.assignedSchedulers.filter(item => {
    //  this.assignSchedulerRequest.schedulers.push(item);
    //})
    this.newSchedulers.filter(item => {
      this.assignSchedulerRequest.isAssigned = true;
      //item.assignChanged = true;
      this.assignSchedulerRequest.schedulerId = item.schedulerId;
    })
    //this.assignSchedulerRequest.projectId = this._localStorage.retrieve("project").projectId;
    //this.assignSchedulerRequest.projectId = this._assignForm.value.selectedProject;
    this.assignSchedulerRequest.updatedBy = this._localStorage.retrieve('profile').displayName;
    //alert(this.assignSchedulerRequest.schedulers[0].schedulerName+'<>'+this.assignSchedulerRequest.projectId);
    /* this.assignSchedulerRequest.schedulers.filter(item => {
      alert(item.schedulerId + "<->" + item.schedulerName);
    }) */
    //this.assignSchedulerRequest.batches = this._assignForm.value.assignedBatches;
    //alert(this.assignSchedulerRequest.batches);
    this.schedulerService.assignSchedulers(this.assignSchedulerRequest)
      .subscribe(result => {
        if (!result) {
          return;
        }
        console.log(result);
        this._notificationService.success('Assigned successfully');
        this.dialogRef.close(this._assignForm.value);
      }, error => console.log(error));
  }

  deassign() {
    this.assignSchedulerRequest = this._assignForm.value;
    //this.assignSchedulerRequest.schedulers = [];
    //this.assignedSchedulers.filter(item => {
    //  if(item.schedulerId === this.assignedScheduler.schedulerId){
    //    item.isAssigned = false;
    //    item.assignChanged = true;
    //  }
    //  this.assignSchedulerRequest.schedulerId = item.schedulerId;
    //})
    this.newSchedulers.filter(item => {
      this.assignSchedulerRequest.isAssigned = false;
      this.assignSchedulerRequest.schedulerId = item.schedulerId;
    })
    //this.assignSchedulerRequest.projectId = this._localStorage.retrieve("project").projectId;
    //this.assignSchedulerRequest.projectId = this._assignForm.value.selectedProject;
    this.assignSchedulerRequest.updatedBy = this._localStorage.retrieve('profile').displayName;
    //alert(this.assignSchedulerRequest.schedulers[0].schedulerName+'<>'+this.assignSchedulerRequest.projectId);
    /* this.assignSchedulerRequest.schedulers.filter(item => {
      alert(item.schedulerId + "<->" + item.schedulerName);
    }) */
    this.schedulerService.assignSchedulers(this.assignSchedulerRequest)
      .subscribe(result => {
        if (!result) {
          return;
        }
        console.log(result);
        this._notificationService.success('Deassigned successfully');
        this.dialogRef.close(this._assignForm.value);
      }, error => console.log(error));
  }
}
